(() => {
'use strict';
if (window.egpOralCare) { window.egpOralCare.init(document); return; }
const prices={bundle:93000,brush:110000,powder:20000};
const names={bundle:'brush set + powder',brush:'electric toothbrush set',powder:'Welsunde tooth powder'};
const money=cents=>'R'+(cents/100).toLocaleString('en-US',{maximumFractionDigits:0});
const controllers=new Map();
function setup(root){
if(controllers.has(root)) return;
const controller=new AbortController(), signal=controller.signal;
let products={};
try { products=JSON.parse(root.querySelector('[data-egp-products]').textContent); } catch(e) { console.error('Unable to load product options',e); }
const initial=root.dataset.egpInitialOffer;
if(!root.dataset.egpDefaultApplied && prices[initial]) root.querySelectorAll('[name="egp-offer"]').forEach(input=>{input.checked=input.value===initial;});
if(!root.dataset.egpDefaultApplied){
const requested=new URLSearchParams(window.location.search).get('variant');
const selected=(products[initial]||[]).find(variant=>String(variant.id)===requested);
if(selected)root.querySelectorAll('[name="egp-colour"]').forEach(input=>{input.checked=(selected.options||[]).some(option=>String(option).toLowerCase()===input.value);});
}
root.dataset.egpDefaultApplied='true';
function update(){
const colour=root.querySelector('[name="egp-colour"]:checked')?.value||'black';
const offer=root.querySelector('[name="egp-offer"]:checked')?.value||'bundle';
const quantity=Math.max(1,parseInt(root.querySelector('[data-egp-quantity]')?.value,10)||1);
const variants=products[offer]||[];
const variant=offer==='powder'?variants[0]:variants.find(v=>(v.options||[]).some(option=>String(option).toLowerCase()===colour));
root.querySelector('[data-egp-variant]').value=variant?.id||'';
const add=root.querySelector('[data-egp-add]');
add.disabled=!variant?.available;
add.textContent=variant?.available?'Add to cart ↗':'Currently unavailable';
root.querySelectorAll('[data-egp-colour-image]').forEach(image=>{image.hidden=image.dataset.egpColourImage!==(offer==='powder'?'powder':colour);});
root.querySelector('[data-egp-selection-label]').textContent=(quantity>1?quantity+' × ':'')+(offer==='powder'?'':colour[0].toUpperCase()+colour.slice(1)+' ')+names[offer];
root.querySelector('[data-egp-selection-price]').textContent=money((variant?.price||prices[offer])*quantity);
root.querySelector('[data-egp-saving]').textContent=offer==='bundle'?'R1,300 separately. Save R370 per bundle.':'Separate-item price. Save R370 with the R930 pair.';
const colours=root.querySelector('.egp-colours'); colours.hidden=offer==='powder'; colours.disabled=offer==='powder';
root.querySelector('.egp-set-label').hidden=offer==='powder';
}
root.addEventListener('change',update,{signal});
root.querySelector('[data-egp-quantity]').addEventListener('input',update,{signal});
update(); controllers.set(root,controller);
}
const init=container=>container.querySelectorAll('[data-egp-root]').forEach(setup);
const teardown=container=>{for(const [root,controller] of controllers)if(container===root||container.contains(root)){controller.abort();controllers.delete(root);}};
window.egpOralCare={init};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>teardown(event.target));
window.addEventListener('pagehide',()=>teardown(document));window.addEventListener('pageshow',()=>init(document));
})();
